import React from 'react';

export default function BlockerSubtitle({subtitle}) {
  if(!subtitle) {
    return null;
  }

  return <div className="subtitle">{subtitle}</div>;
};
